import React from "react";
import { useLang } from "@/i18n";
import BookingDialog from "@/components/BookingDialog";
import { Phone, Mail, MapPin, Instagram, MessageCircle } from "lucide-react";

export default function Contact() {
  const { t } = useLang();
  return (
    <div className="section-band">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid gap-12 md:grid-cols-2">
      <div>
        <div className="text-xs uppercase tracking-[0.35em] text-brand-orange font-semibold mb-3">{t("nav.contact")}</div>
        <h1 className="font-serif text-5xl md:text-6xl text-brand-navy" data-testid="contact-title">
          {t("cta.inquire")}
        </h1>
        <p className="mt-4 text-slate-700 max-w-md">{t("hero.subtitle")}</p>

        <div className="mt-10 space-y-4 text-brand-navy">
          <div className="flex items-center gap-3"><Phone className="text-brand-orange" size={18}/> +90 555 000 00 00</div>
          <div className="flex items-center gap-3"><Mail className="text-brand-orange" size={18}/> info@ariaf.com</div>
          <div className="flex items-center gap-3"><MessageCircle className="text-brand-orange" size={18}/> WhatsApp: +90 555 000 00 00</div>
          <div className="flex items-center gap-3"><MapPin className="text-brand-orange" size={18}/> Makkah</div>
          <div className="flex items-center gap-3"><Instagram className="text-brand-orange" size={18}/> @ariafcatering</div>
        </div>

        <div className="mt-10">
          <BookingDialog />
        </div>
      </div>
      <div className="bg-canvas-stone rounded-3xl p-8 md:p-12 border border-brand-gold/20">
        <div className="text-brand-gold uppercase tracking-[0.35em] text-xs font-semibold">Ariaf</div>
        <div className="font-serif text-3xl text-brand-navy mt-3">{t("tagline")}</div>
        <div className="mt-6 aspect-[4/3] rounded-2xl overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1780776614340-cbaa364d3d52?crop=entropy&cs=srgb&fm=jpg&q=85"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
    </div>
  );
}
